//messages.js
export default {
    // PURCHASE ORDERS
    purchase_order_id: "Purchase Order #",
    order_date: "Order Date",
    expected_delivery_date: "Expected Delivery Date",
    work_order_no: "Work Order #",
    edit_purchase_order: "Edit Purchase Order",
    add_purchase_order: "Add Purchase Order",
    delete_purchase_order: "Delete Purchase Order",
    delete_purchase_order_confirm: "This action is not reversible!",
    purchase_orders: "Purchase Orders",
    purchase_order: "Purchase Order",

    purchase_order_detail_id: "ID",
    edit_purchase_order_detail: "Edit Purchase Order Detail",
    add_purchase_order_detail: "Add Purchase Order Detail",
    delete_purchase_order_detail: "Delete Purchase Order Detail",
    purchase_order_details: "Purchase Order Details",

    receipt_id: "Receipt #",
    receipt_date: "Receipt Date",
    received_quantity: "Received Quantity",
    received_cost: "Received Cost",
    received_by: "Received By",
    edit_inventory_receipt: "Edit Inventory Receipt",
    add_inventory_receipt: "Add Inventory Receipt",
    delete_inventory_receipt: "Delete Inventory Receipt",
    inventory_receipts: "Inventory Receipts",
    ordered: "Ordered",
    received: "Received",
    in_transit: "In Transit",
    quantity_to_receive: "Quantity to Receive",
    received_cost: "Received Cost",
    freight_term_id: "Freight Term",
    proforma_invoice_number: "Proforma Invoice #",
    attention_to: "Attention To",
    done: "Done",
    vendor_quote_number: "Vendor Quote #",
};
